import React from "react";
import styled from "styled-components";
import ErrorMessageDetailsMessageRow from "./ErrorMessageDetailsMessageRow/ErrorMessageDetailsMessageRow";
const StyledErrorMessageDetailsMessages = styled.div `
  width: calc(35% - 10px);
  height: 100%;
  max-width: calc(35% - 10px);
  padding: 5px;
  float: left;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
`;
class ErrorMessageDetailsMessages extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(StyledErrorMessageDetailsMessages, { className: "error-message-details-messages-container" },
            React.createElement("label", { style: { marginBottom: "1rem" } }, "Messages:"),
            this.props.orderErrorDetails.map(message => {
                return (React.createElement(ErrorMessageDetailsMessageRow, { orderErrorDetails: message, handleMessageRowClick: this.props.handleMessageRowClick, handleCheckboxChange: this.props.handleCheckboxChange }));
            })));
    }
}
export default ErrorMessageDetailsMessages;
